import React from 'react'
import {Stack , Box} from '@mui/material'
import VideoCard from './VideoCard'
import ChannelCard from './ChannelCard'
function Videos({videos , direction}) {
    if (!videos?.length) return "Loading..."
    return (
        <Stack direction={direction || "row"} flexWrap='wrap' justifyContent='flex-start' gap={2}>
            {videos?.map((item ,index) => (
                <Box key={index} >
                    {item?.id?.videoId && <VideoCard video={item} />}
                    {item?.id?.channelId && <ChannelCard channel={item} />}
                </Box>
            ))}
        </Stack>
    )
}

export default Videos